import { render, staticRenderFns } from "./SetFiles.vue?vue&type=template&id=5157c6e9&scoped=true"
import script from "./SetFiles.vue?vue&type=script&lang=js"
export * from "./SetFiles.vue?vue&type=script&lang=js"
import style0 from "./SetFiles.vue?vue&type=style&index=0&id=5157c6e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5157c6e9",
  null
  
)

export default component.exports